export const getHotelPricesWithDays = (
    mealPlans = [],
    numberOfDays = 1,
    isSeason = false
  ) => {
    const result = {
      student: { weekdays: 0, weekends: 0 },
      adult: { weekdays: 0, weekends: 0 },
    };

    if (!Array.isArray(mealPlans) || mealPlans.length === 0) return result;

    mealPlans.forEach((mealPlan) => {
      const label = (mealPlan.label || "").toLowerCase();

      const rawPrice = isSeason ? mealPlan.sph : mealPlan.pph;
      const price = Number(rawPrice);
      if (isNaN(price) || price === 0) return;

      const totalPrice = price * numberOfDays;

      const isAdult = label.includes("adult");
      const isStudent = !isAdult || label.includes("to");

      const isWeekdays = label.includes("weekday");
      const isWeekends = label.includes("weekend");

      // Assign price based on flags
      if (isWeekdays) {
        if (isAdult) result.adult.weekdays += totalPrice;
        if (isStudent) result.student.weekdays += totalPrice;
      }

      if (isWeekends) {
        if (isAdult) result.adult.weekends += totalPrice;
        if (isStudent) result.student.weekends += totalPrice;
      }

      // If neither weekday/weekend explicitly mentioned, add to both
      if (!isWeekdays && !isWeekends) {
        if (isAdult) {
          result.adult.weekdays += totalPrice;
          result.adult.weekends += totalPrice;
        }
        if (isStudent) {
          result.student.weekdays += totalPrice;
          result.student.weekends += totalPrice;
        }
      }
    });

    return result;
  };

 export const validateFile = (file) => {
    if (!file.type.startsWith("image/")) {
      return "Only image files are allowed.";
    }
    if (file.size > 9000 * 1024) {
      return "File size should not exceed 9MB.";
    }
    return null;
  };